import React, { useEffect, useState } from 'react'
import Drawer from 'components/Drawer'
import {
  StyledTab,
  CandidatesSpan,
} from 'modules/Page/Components/Partials/NotificationDrawer/style'
import NotificationDetails from 'modules/Page/Components/Partials/NotificationDrawer/AllNotificationDetails/index'
import { useSelector } from 'react-redux'
import { removeDuplicatesFromArray } from 'utils/removeDuplicatesFromArray'

const Notification = ({
  notification,
  setNotification,
  getUserNotifications,
  notificationData,
  markNotificationReadApi,
}) => {
  const useId = useSelector(state => state.auth.userId)
  const [selectedTab, setSelectedTab] = useState('notification')

  const [allNotificationLoading, setAllNotificationLoading] = useState(true)
  const [allNotificationHasMoreData, setAllNotificationHasMoreData] =
    useState(true)
  const [allNotificationListData, setAllNotificationListData] = useState([])
  const [allNotificationPageNo, setAllNotificationPageNo] = useState(1)
  const [allNotificationCount, setAllNotificationCount] = useState(0)

  const [actionLoading, setActionLoading] = useState(true)
  const [actionHasMoreData, setActionHasMoreData] = useState(true)
  const [actionListData, setActionListData] = useState([])
  const [actionPageNo, setActionPageNo] = useState(1)
  const [actionCount, setActionCount] = useState(0)

  const notificationAsRead = payload => {
    markNotificationReadApi({ userId: useId, payload: payload })
  }

  useEffect(() => {
    if (notification) {
      loadMoreData({
        pageNo: allNotificationPageNo,
        setLoading: setAllNotificationLoading,
        listData: allNotificationListData,
        setListData: setAllNotificationListData,
        setHasMoreData: setAllNotificationHasMoreData,
        setTotalCount: setAllNotificationCount,
        isAction: false,
      })
    }
  }, [notification, allNotificationPageNo])

  useEffect(() => {
    if (notification) {
      loadMoreData({
        pageNo: actionPageNo,
        setLoading: setActionLoading,
        listData: actionListData,
        setListData: setActionListData,
        setHasMoreData: setActionHasMoreData,
        setTotalCount: setActionCount,
        isAction: true,
      })
    }
  }, [notification, actionPageNo])

  const loadMoreData = async ({
    pageNo,
    setLoading,
    listData,
    setListData,
    setHasMoreData,
    setTotalCount,
    isAction,
  }) => {
    const { data } = await getUserNotifications({
      userId: useId,
      currentPage: pageNo,
      isAction: isAction,
      setLoading: setLoading,
    })

    if (data?.data?.list?.length) {
      setTotalCount(data.data?.count)
      const pendingList = [...listData, ...data.data.list]
      const arrFiltered = removeDuplicatesFromArray(pendingList, '_id')
      setListData(arrFiltered)
    } else {
      setTotalCount(0)
      setListData([])
      setHasMoreData(false)
    }
    if (data?.data?.totalPages == 1) {
      setHasMoreData(false)
    }
  }

  const onClose = () => {
    setNotification(false)
    setAllNotificationHasMoreData(true)
    setAllNotificationListData([])
    setAllNotificationPageNo(1)
    setActionHasMoreData(true)
    setActionListData([])
    setActionPageNo(1)
  }

  const content = () => {
    return (
      <StyledTab
        activeKey={selectedTab}
        onChange={key => setSelectedTab(key)}
        items={[
          {
            key: 'notification',
            label: (
              <>
                All Notification{' '}
                <CandidatesSpan>{allNotificationCount}</CandidatesSpan>
              </>
            ),
            children: (
              <NotificationDetails
                notificationData={notificationData}
                notification={notification}
                setNotification={setNotification}
                notificationAsRead={notificationAsRead}
                loading={allNotificationLoading}
                hasMoreData={allNotificationHasMoreData}
                setHasMoreData={setAllNotificationHasMoreData}
                listData={allNotificationListData}
                pageNo={allNotificationPageNo}
                setPageNo={setAllNotificationPageNo}
              />
            ),
          },
          {
            key: 'required',
            label: (
              <>
                Action Required <CandidatesSpan>{actionCount}</CandidatesSpan>
              </>
            ),
            children: (
              <NotificationDetails
                notificationData={notificationData}
                notification={notification}
                setNotification={setNotification}
                notificationAsRead={notificationAsRead}
                loading={actionLoading}
                hasMoreData={actionHasMoreData}
                setHasMoreData={setActionHasMoreData}
                listData={actionListData}
                pageNo={actionPageNo}
                setPageNo={setActionPageNo}
              />
            ),
          },
        ]}
      />
    )
  }
  const footer = () => {}
  return (
    <Drawer
      width="40%"
      title={'Notification'}
      placement="right"
      visible={notification}
      content={content()}
      footer={footer()}
      onClose={onClose}
      closable
    />
  )
}

export default Notification
